import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";


const enum fields {
    customerpartnumberlabel = "customerpartnumberlabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.customerpartnumberlabel]: string;
    };
}
type Props = WidgetProps & HasProduct;
export interface ProductDetailsCustomerPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    fitContent?: InjectableCss;
}

export const customerPartNumberStyles: ProductDetailsCustomerPartNumberStyles = {
    labelText: {
        size: 14,
        weight: "bold",
        css: css`
            margin-right: .18750625rem;
            white-space: nowrap;
        `,
    },
    valueText: {
        size: 14,
        css: css`
            margin-bottom: .31250625rem;
        `,
    },
    fitContent: {
        css: css`
        width: fit-content;
        float:left;
        padding-right:.3rem;
         }
        `,
    },
};

const styles = customerPartNumberStyles;

const ProductDetailsCustomerPartNumber: React.FC<Props> = ({fields, product }) => {
    if (!product.customerProductNumber) {
        return null;
    }

    return (
        <Typography {...styles.valueText} {...styles.fitContent} as="p">
            <Typography {...styles.labelText}>
            {translate(fields.customerpartnumberlabel) || translate("My Part #")}
            </Typography>
            {product.customerProductNumber}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsCustomerPartNumber),
    definition: {
        displayName: "Customer Part Number",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.customerpartnumberlabel,
                editorTemplate: "TextField",
                defaultValue: "Your Part Number:",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
